import { Popover } from "@mui/material";

import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";

interface PickerPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: ReactNode;
  /** Merged into the paper slot sx for per-picker layout (overflow, padding). */
  paperSx?: SxProps<Theme>;
}

/**
 * Shared popover shell for the merge-tag and offer pickers, so their
 * positioning and paper sizing stay in sync. Each picker supplies its own
 * content and layout via `children` + `paperSx`.
 */
export function PickerPopover({
  anchorEl,
  onClose,
  children,
  paperSx,
}: PickerPopoverProps) {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          elevation: 1,
          sx: [{ maxHeight: 320, width: 280 }, paperSx ?? {}],
        },
      }}
    >
      {children}
    </Popover>
  );
}
